'use client';

var ECalendarType;
(function (ECalendarType) {
    ECalendarType["month"] = "month";
    ECalendarType["year"] = "year";
    ECalendarType["decade"] = "decade";
    ECalendarType["combine"] = "combine";
    ECalendarType["combineMonthAndYear"] = "combineMonthAndYear";
})(ECalendarType || (ECalendarType = {}));
var ECalendarStyle;
(function (ECalendarStyle) {
    ECalendarStyle["single"] = "single";
    ECalendarStyle["range"] = "range";
})(ECalendarStyle || (ECalendarStyle = {}));

export { ECalendarStyle, ECalendarType };
//# sourceMappingURL=types.js.map
